import {
    root,
    MuiTheme,
    breakpoints,
    pseudoLink,
    startAdornment,
    textField,
} from 'assets/theme';

import background from 'assets/img/login/background.jpg'

const AuthPageSharedStyle = {
    root: {
        ...root,
        height: '100vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
    },
    sharedInputSection: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    sharedInputSectionInput: {
        '&:first-of-type': {
            marginRight: '10px'
        },
        '&:last-of-type': {
            marginLeft: '10px'
        },
        flex: 1,
    },
    startAdornment: {
        ...startAdornment,
    },
    textField: {
        ...textField
    },
    imageContainer: {
        '&:after': {
            position: 'absolute',
            top: '0',
            left: '0',
            content: "''",
            height: '100%',
            width: '100%',
            backgroundColor: 'rgba(0,0,0,0.4)'
        },
        position: 'relative',
        flex: '3',
        background: `url(${background}) no-repeat fixed`,
        backgroundSize: 'cover',
        backgroundPosition: 'calc(50% - 100px) 50%',
        zIndex: '0',
    },
    formContainer: {
        flex: '1',
        backgroundColor: MuiTheme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '15px 20px',
        boxSizing: 'border-box',
        position: 'relative',
        minWidth: '320px',
        // WebkitBoxShadow: "-4px 0px 9px 0px rgba(0,0,0,0.45)",
        // MozBoxShadow: "-4px 0px 9px 0px rgba(0,0,0,0.45)",
        // boxShadow: "-4px 0px 9px 0px rgba(0,0,0,0.45)"
    },
    logo: {
        display: 'block',
        width: '40%',
        minWidth: '200px',
        maxHeight: '100%',
        margin: '20px auto',
        marginBottom: '30px',
    },
    extraActions: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        margin: '15px 0'
    },
    pseudoLink: {
        ...pseudoLink
    },
    form: {
        width: '50%',
        maxWidth: '500px',
        minWidth: '300px',
        margin: '0 auto'
    },
    submitButton: {
        '&:hover': {
            background: MuiTheme.palette.secondary.dark
        },
        background: MuiTheme.palette.secondary.main,
        borderRadius: '2px',
        width: '100%',
        margin: '15px auto',
        color: MuiTheme.palette.secondary.contrastText,
        padding: '7px 0',
        WebkitBoxShadow: "1px 1px 3px 0px rgba(0,0,0,0.25)",
        MozBoxShadow: "1px 1px 3px 0px rgba(0,0,0,0.25)",
        boxShadow: "1px 1px 3px 0px rgba(0,0,0,0.25)"
    },

    [breakpoints.medium]: {
        imageContainer: {
            backgroundSize: '100% 100%',
            backgroundPosition: 'calc(50% - 200px) 50%',
        },
    },
    [breakpoints.small]: {
        imageContainer: {
            display: 'none'
        },
        logo: {
            width: '35%',
            minWidth: '150px'
        },
        logoContainer: {
            marginBottom: '0 !important'
        }
    }
};

export default AuthPageSharedStyle;
